module.exports = __webpack_public_path__ + "static/media/finished.e122ff83.svg";